import Swiper, {Pagination, Navigation} from 'swiper';
Swiper.use([Navigation]);

$(document).ready(function() {
    if ($(window).width() < 960) {
        const swiper = new Swiper('.swiper', {
            slidesPerView: 1,
            loop: false,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    };
});